import type { Infer } from 'superstruct';
import {
	enums,
	integer,
	nullable,
	object,
	optional,
	unknown,
} from 'superstruct';

import { HISTORY_ACTION_TYPES, HISTORY_ENTITY_TYPES } from './history-types';

/**
 * DTO used in the backend to add an history event.
 * This type is purposefully open to reduce the
 * possibility of unexpected type errors breaking
 * the history log.
 *
 * The passed data is processed in the history module.
 *
 * NOTE: This should not be used for API validation.
 */
export const AddHistoryEventDto = object({
	entityType: enums(HISTORY_ENTITY_TYPES),
	entityId: integer(),
	action: enums(HISTORY_ACTION_TYPES),
	oldData: optional(nullable(unknown())),
	newData: unknown(),
});

export type AddHistoryEventDto = Infer<typeof AddHistoryEventDto>;
